import React, { useEffect, useState } from "react";
import "../../css_files/Reports/GenerateReport.css";
import axiosInstance from "../../api";

function GenerateReport({
  setSalesData,
  setTicketsData,
  setTechnicalData,
  setOutstandingData,
}) {
  const [data, setData] = useState({
    month: "",
    year: "",
    type: "",
    report: "",
    role: "",
  });

  function handleChange(e) {
    setData({ ...data, [e.target.name]: e.target.value });
  }

  function getAllOrders() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetDetails?type=${
          data.type
        }&year=${data.year || 0}&month=${data.month || 0}`
      )
      .then((res) => {
        setSalesData(res.data);
      })
      .catch(console.log);
  }

  function getAllTickets(year, month, type) {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket?page=1`)
      .then(async (res) => {
        const resArr = res.data.data;
        for (let i = 2; i <= res.data.pages; i++) {
          const res = await axiosInstance.get(
            `${process.env.REACT_APP_API_URL}/api/v1/Ticket?page=${i}`
          );
          resArr.push(...res.data.data);
        }
        setTicketsData(
          resArr.filter((x) => {
            if (year === "" && month === "" && type === "") {
              return x;
            } else if (year === "" && month === "") {
              return x.enquiryType === type;
            } else if (year === "" && type === "") {
              return x.seriesId.slice(4, 6) == month;
            } else if (month === "" && type === "") {
              return x.seriesId.slice(0, 4) == year;
            } else if (type === "") {
              return (
                x.seriesId.slice(4, 6) == month &&
                x.seriesId.slice(0, 4) == year
              );
            } else if (month === "") {
              return x.enquiryType === type && x.seriesId.slice(0, 4) == year;
            } else if (year === "") {
              return x.seriesId.slice(4, 6) == month && x.enquiryType === type;
            } else {
              return (
                x.seriesId.slice(4, 6) == month &&
                x.seriesId.slice(0, 4) == year &&
                x.enquiryType === type
              );
            }
          })
        );
      })
      .catch(console.log);
  }

  function getTechnicals(role) {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/TicketAccess`)
      .then((res) => {
        setTechnicalData(
          res.data.filter((x) => {
            if (role === "") return true;
            return x.user.role === role;
          })
        );
      })
      .catch(console.log);
  }

  function getOutstanding() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetDetails?type=${
          data.type
        }&year=${data.year || 0}&month=${data.month || 0}`
      )
      .then((res) => {
        setOutstandingData(res.data);
      })
      .catch(console.log);
  }

  return (
    <form
      className="generate-report"
      onSubmit={(e) => {
        e.preventDefault();
        switch (data.report) {
          case "Sales Breakdown":
            getAllOrders();
            setTicketsData([]);
            setTechnicalData([]);
            setOutstandingData([]);
            break;
          case "Tickets Report":
            getAllTickets(data.year, data.month, data.type);
            setSalesData([]);
            setTechnicalData([]);
            setOutstandingData([]);
            break;
          case "Technical Report":
            getTechnicals(data.role);
            setTicketsData([]);
            setSalesData([]);
            setOutstandingData([]);
            break;
          case "Outstanding Report":
            getOutstanding();
            setTicketsData([]);
            setTechnicalData([]);
            setSalesData([]);
            break;
        }
      }}
    >
      <h1>Report Generation Form</h1>
      {data.report !== "Technical Report" ? (
        <>
          <blockquote>
            <label>Month</label>
            <select onChange={handleChange} name="month">
              <option value="">Select Month</option>
              <option value="01">January</option>
              <option value="02">February</option>
              <option value="03">March</option>
              <option value="04">April</option>
              <option value="05">May</option>
              <option value="06">June</option>
              <option value="07">July</option>
              <option value="08">August</option>
              <option value="09">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </blockquote>
          <blockquote>
            <label>Year</label>
            <select onChange={handleChange} name="year">
              <option value="">Select Year</option>
              <option value="2016">2016</option>
              <option value="2017">2017</option>
              <option value="2018">2018</option>
              <option value="2019">2019</option>
              <option value="2020">2020</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
            </select>
          </blockquote>
          <blockquote>
            <label>Type</label>
            <select onChange={handleChange} name="type">
              <option value="">Select Type</option>
              <option value="Service">Service</option>
              <option value="Parts">Parts</option>
            </select>
          </blockquote>
        </>
      ) : (
        <blockquote>
          <label>Role</label>
          <select onChange={handleChange} name="role">
            <option value="">Select Role</option>
            <option value="Service-Co-Ordinator">Service-Co-Ordinator</option>
            <option value="Accounts">Accounts</option>
            <option value="Store Manager">Store Manager</option>
            <option value="Technician">Technician</option>
            <option value="Purchase Manager">Purchase Manager</option>
          </select>
        </blockquote>
      )}

      <blockquote>
        <label>Report</label>
        <select required onChange={handleChange} name="report">
          <option value="">Select Report</option>
          <option value="Sales Breakdown">Sales Breakdown</option>
          <option value="Technical Report">Technical Report</option>
          <option value="Outstanding Report">Outstanding Report</option>
          <option value="Tickets Report">Tickets Report</option>
          <option value="Visits Report">Visits Report</option>
          <option value="Performance Report">Performance Report</option>
          <option value="Commission and Spare Report">
            Commission and Spare Report
          </option>
          <option value="Top Selling Products Report">
            Top Selling Products Report
          </option>
        </select>
      </blockquote>
      <button>Generate Report</button>
    </form>
  );
}

export default GenerateReport;
